import React from 'react';
import './Home.css';

function Training() {
  return (
    <div className='HomeBody'>
      <p>Training Section</p>
      <p>Please select desired option.</p>
    </div>
  );
}

export default Training;
